import React from 'react';
import PropTypes from 'prop-types';
import { withApi } from '@tencent/react-aio';
import { Dialog, Table, Column } from '@tencent/spaui';
import Decorate from '@tencent/spaui-decorate';
import { SMB_FLAG } from '@/constants/Constants';
import _ from 'lodash';
import message from '@/utils/message';
import DateTime from '@/components/DateTime';
import perms from '@/common/permissions/sale/perms';
import { withAccount } from '@/business-components/operator/account-context';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import UserInfo from '@/business-components/sale/UserInfo';
import './style.scoped.less';
const dialog = new Decorate(Dialog);
// 可审核config list, 0: "未保护", 2: "拒绝保护"
const auditableConfig = [0, 2];
// 申请中，30天后可重新申请
const reapplyList = [1];
class CustomerFollowUpRecord extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    callback: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      recordData: {},
    };
    this.disable = false;
  }

  componentDidMount() {
    const { lead = {} } = this.props;
    const { customerMpAppId, leadId } = lead;
    if (customerMpAppId && customerMpAppId.startsWith('wx')) {
      this.getRecordData({
        leadId,
        appid: customerMpAppId,
      });
    }
  }

  getRecordData = (params) => {
    const { webApi } = this.props;
    webApi
      .searchProtectionInfo()
      .ajaxJson({
        data: params,
      })
      .then((res) => {
        if (res && res.ret === 0) {
          const { data = {} } = res;
          const { actions = [] } = data;
          const _data = {
            createdTime: data.smb_change_time * 1000,
          };
          this.setState({
            recordData: {
              ...data,
              actions: actions.length > 0 ? actions : [_data],
            },
          });
        }
      })
      .catch((err) => {
        this.setState({ recordData: {} });
      });
  }

  renderRecord = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    return '申请客保';
  }

  renderTime = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      return <DateTime dateTime={value} />;
    }
    return '-';
  }

  renderUser = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    return <UserInfo userId={value} />;
  }

  handleOpen = () => {
    const _this = this;
    dialog.setProps({
      style: {
        width: '400px',
      },
      backdrop: true,
      title: '申请',
      show: true,
      children: <div>确定发送客保申请?</div>,
      onClose() {
        _this.handleClose();
      },
      onCancel() {
        _this.handleClose();
      },
      onSubmit() {
        _this.fetch();
      },
    });
  }

  handleClose = () => {
    dialog.setProps({
      show: false,
    });
  }

  fetch = () => {
    if (this.disable) return;
    const { webApi, callback, lead = {} } = this.props;
    const { leadId, createdTime, customerMpAppId, agencyId } = lead;
    const params = {
      leadId,
      appId: customerMpAppId,
      firstCallTime: createdTime,
      agencyId,
    };
    this.disable = true;
    webApi
      .customerProtection()
      .ajaxJson({
        data: params,
      })
      .then((res) => {
        this.disable = false;
        if (res && res.ret === 0) {
          callback && callback();
          this.getRecordData({
            leadId,
            appid: customerMpAppId,
          });
          this.handleClose();
        } else {
          message.strongwarn(res?.msg);
        }
      })
      .catch((err) => {
        this.disable = false;
        message.strongwarn(err?.message);
      });
  }

  // 判定申请时间是否为30天之后，是的话可以重新发送申请
  getChangeTime = () => {
    const { recordData } = this.state;
    if (_.includes(reapplyList, recordData.smb_flag) && recordData.smb_change_time) {
      return dayjs(new Date()).subtract(30, 'day')
        .isAfter(dayjs(recordData.smb_change_time * 1000));
    }
    return false;
  }

  render() {
    const { recordData } = this.state;
    const {
      lead = {},
      account: { saleStatus },
      whiteList,
    } = this.props;
    const { agencyId, grayPermissions = [] } = saleStatus || {};
    const { customerMpAppId, intention } = lead;
    const { adPlatformTypes } = intention || {};
    // 直销判定
    const isDirectSales = _.includes(whiteList.data, agencyId);
    console.log(whiteList, isDirectSales, 111);
    console.log(adPlatformTypes, 222);
    // 灰度权限判定
    // 不是直销 或 没有销售灰度（id 8201）或 推广目标不包含微信 或 没有lead.customerMpAppId 或 lead.customerMpAppId不已'wx' 开头的，都看不到
    if (!isDirectSales || !_.includes(grayPermissions, perms.GRAY_GDT_PROTECTION) || !adPlatformTypes?.includes('AD_PLATFORM_TYPE_MP') || !customerMpAppId || (customerMpAppId && !customerMpAppId.startsWith('wx'))) {
      return null;
    }
    return (
      <div className="customer-follow-record">
        <h2>客保跟进记录</h2>
        <div className="follow-record-toolbar">
          <p>
            MP客保状态: {SMB_FLAG[recordData?.smb_flag] || '-'}
            {/* {customerMpAppId && (auditableConfig.indexOf(recordData?.smb_flag) > -1 || this.getChangeTime()) ? <span onClick={this.handleOpen}> 发送客保申请</span> : null}*/}
          </p>
        </div>
        <Table data={recordData?.actions || []}>
          <Column name="createdByUserId" render={this.renderUser}>
            操作人
          </Column>
          <Column name="recordId" render={this.renderRecord}>
            操作记录
          </Column>
          <Column name="createdTime" render={this.renderTime}>
            时间
          </Column>
          <Column name="responseMessage">
            系统返回结果
          </Column>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    whiteList: state.customerProtectionWhiteList,
  };
}

export default withApi(withAccount(connect(mapStateToProps, {})(CustomerFollowUpRecord)));
